import { Capacitor } from '@capacitor/core';
import Phaser from 'phaser';
import './auth/auth-shell.css';
import './ui/game-loading.css';
import { createGameConfig } from './game/config';
import { preloadHudFont } from './game/fonts';
import { bindAdaptiveViewbox } from './game/viewbox';
import { bindHudViewportFit } from './game/viewport-fit';
import { onceGame, GameEvents } from './game/events';
import {
  showGameLoading,
  signalGameReady,
  waitForGameReady,
} from './ui/game-loading';
import {
  destroyGameInstance,
  handleSessionExpired,
  runAuthGate,
  setGameInstance,
} from './boot';
import { hideAuthShell } from './auth/auth-gate';

async function startPhaser(parent: HTMLElement) {
  destroyGameInstance();
  showGameLoading('Preparing your smash adventure…');
  // Auth shell sits under the loader — drop it once the overlay is painted.
  requestAnimationFrame(() => hideAuthShell());

  onceGame(GameEvents.GAME_READY, () => signalGameReady());

  await preloadHudFont();
  const game = new Phaser.Game(createGameConfig(parent));
  setGameInstance(game);
  const shell = document.getElementById('viewbox-shell');
  if (shell) bindAdaptiveViewbox(game, shell);
  bindHudViewportFit(game);

  await waitForGameReady();
}

async function boot() {
  const shell = document.getElementById('viewbox-shell');
  const parent = document.getElementById('game-root');
  if (!shell || !parent) {
    throw new Error('Missing #viewbox-shell or #game-root element');
  }

  if (Capacitor.isNativePlatform()) {
    document.body.classList.add('native');
  }

  window.addEventListener('booga:session-expired', () => {
    handleSessionExpired();
  });

  window.addEventListener('booga:restart-auth', () => {
    void (async () => {
      await runAuthGate({ skipSplash: true });
      await startPhaser(parent);
    })();
  });

  await runAuthGate();
  await startPhaser(parent);
}

void boot();
